import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import PrimeConfirmDialog from "../../components/dialog/PrimeConfirmDialog";
import PrimeDialog from "../../components/dialog/PrimeDialog";
import NoInfo from "../../components/NoInfo";
import PrimeTableFooter from "../../components/PrimeTableFooter";
import { useEditableFlag } from "../../hooks/useEditableFlag";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import { MessageContext, handleSuccessMessage } from "../../store/messageStore";
import NumberUtil from "../../utility/NumberUtil";
import { AlertService } from "../../utility/service/alert-service";
import { handleFileDownloadRes } from "../../utility/service/api-base";
import { getSubItemsByItemNo } from "../../utility/service/api-service";
import {
  copyCarbonFootprint,
  deleteFootprintItem,
  exportCarbonFootprint,
  queryCarbonFootprintList,
  queryCompanyProduct,
} from "../../utility/service/carbonFootprint-service";
import { queryCompanyList } from "../../utility/service/company-service";
import { parseTabPermissions } from "../../utility/service/tab-permission-utils";
import { checkDpSuccess, getCompanyType, getFormErrorMessage } from "../../utility/service/tool-service";
import { AcctContext } from "../../utility/useReduce/userNameReduce";
import { Tooltip } from "primereact/tooltip";

export default function InventoryCarbonFootprint_Index() {
  const [isLoading, setIsLoading] = useState(false);
  const [companyPlaceList, setCompanyPlaceList] = useState();
  const [, loading] = useContext(SystemLoading);
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [addDialog, setAddDialog] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    itemObj,
    setItemObj,
    action,
    setAction,
    setTab1Action,
    setReportListObj,
    currentComSeq,
    setCurrentComSeq,
    companyName,
    setCompanyName,
  } = useOutletContext();
  const [carbonFpId, setCarbonFpId] = useState("");
  const [carbonFootprintLists, setCarbonFootprintLists] = useState([]);
  const [productTypeList, setProductTypeList] = useState([]);
  const [delDialog, setDelDialog] = useState(false);
  const [delObj, setDelObj] = useState({});
  const [createButtonFlag, setCreateButtonFlag] = useState(false);
  const [limitDialog, setLimitDialog] = useState(false);
  const [copyDialog, setCopyDialog] = useState(false);
  const [copyObj, setCopyObj] = useState({});
  const [copyOffingId, setCopyOffingId] = useState("");
  const [isCopyFile, setIsCopyFile] = useState("Y");
  const [comProductList, setComProductList] = useState([]);
  const isEditable = useEditableFlag("F10503"); // control edit by F10503

  // Tab 權限控制
  const [state] = useContext(AcctContext);
  const [accessibleTabs, setAccessibleTabs] = useState([]);
  const [tooltipTarget, setTooltipTarget] = useState(null);

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    getValues,
    setValue,
    resetField,
    reset: resetForm,
    control,
    trigger,
    reset,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {},
    //錯誤驗證時機
    mode: "all",
  });

  const onSubmit = (data) => {
    setCurrentComSeq(data.companySeq); // 紀錄目前所選的廠商名稱
    axios_queryCarbonFootprintList({
      companySeq: data.companySeq,
      productType: data.productType,
    });
  };

  // 載入 tab 權限
  useEffect(() => {
    const tabPermissions = state?.tabPermissions?.["F10503"];
    if (tabPermissions) {
      const parsedTabs = parseTabPermissions(tabPermissions);
      setAccessibleTabs(parsedTabs);
    } else {
      // 如果沒有權限設定，設為空陣列（無任何權限）
      setAccessibleTabs([]);
    }
  }, [state?.tabPermissions]);

  // 檢查特定 tab 是否有權限
  const hasTabPermission = (tabName) => {
    return accessibleTabs.includes(tabName);
  };

  const createItem = () => {
    navigate("create");
    setAction("create");
    setItemObj({});
  };

  const btnReadMore = () => {
    axios_queryCarbonFootprintList(
      {
        companySeq: getValues("companySeq"),
        carbonFpId,
        productType: getValues("productType"),
      },
      true,
    );
  };

  useEffect(() => {
    axios_queryCompanyList();
    axios_getDropDownList();
    setValue("startYear", "112");
  }, []);

  // 檢查是否是從子頁面返回
  useEffect(() => {
    const isFromChildPage = sessionStorage.getItem("fromInventoryCarbonFootprintChildPage");
    if (isFromChildPage) {
      // 從子頁面返回，清除標記但不重新查詢資料
      sessionStorage.removeItem("fromInventoryCarbonFootprintChildPage");
    }
  }, []);

  const axios_getDropDownList = () => {
    // productType
    getSubItemsByItemNo("PRODUCT_TYPE", 31).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        let newArray = data.map((item, index) => {
          return {
            ...item,
            index: index,
          };
        });
        setProductTypeList(newArray);
      }
    });
  };

  //組織邊界廠商清單
  const axios_queryCompanyList = () => {
    setIsLoading(true);
    queryCompanyList()
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res.data.RespBody.companyList;
          setCompanyPlaceList(data);
          if (getCompanyType() === "A") {
            setValue("companySeq", data[0].companySeq);
            trigger("companySeq");
            setCurrentComSeq(data[0].companySeq); // 紀錄目前所選的廠商名稱
            axios_queryCarbonFootprintList({ companySeq: data[0].companySeq });
            axios_queryCompanyProduct({ companySeq: data[0].companySeq });
            setCompanyName(data[0].companyName);
          } else {
            if (currentComSeq !== "") {
              setValue("companySeq", currentComSeq, { shouldValidate: true });
              axios_queryCarbonFootprintList({
                companySeq: currentComSeq,
              });
            }
          }
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const axios_queryCarbonFootprintList = (reqBody, readMore = false) => {
    checkLoading(loading);
    queryCarbonFootprintList(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res?.data?.RespBody?.carbonFootprintLists;
          setCreateButtonFlag(res?.data?.RespBody?.createButtonFlag);
          if (data?.length > 0) {
            setCarbonFpId(data[data?.length - 1].carbonFpId);
            if (readMore === true) {
              setCarbonFootprintLists((pre) => {
                return [...pre, ...data];
              });
            } else {
              setCarbonFootprintLists((pre) => {
                return [...data];
              });
            }
          } else {
            if (readMore === false) {
              setCarbonFootprintLists([]);
            }
          }
        } else {
          if (readMore === false) {
            setCarbonFootprintLists([]);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => checkLoading(loading, false));
  };

  const editItem = (item, action) => {
    setAction(action);
    item.companySeq = getValues("companySeq");
    let companyList = companyPlaceList?.filter((item) => item.companySeq === getValues("companySeq"));
    item.companyName = companyList[0]?.companyName;
    setItemObj(item);
    navigate(action);
  };

  const deleteItem = (rowData) => {
    setDelObj(rowData);
    setDelDialog(true);
  };

  const exportItem = (rowData) => {
    checkLoading(loading);
    exportCarbonFootprint({ carbonFpId: rowData?.carbonFpId })
      .then((res) => {
        if (res?.status === 200) {
          handleFileDownloadRes(res, `${companyName}_${rowData?.productName}_${rowData?.inspectionDate}.xlsx`);
        } else {
          AlertService.ok(res?.data?.ResHeader?.rtnCode, res?.data?.ResHeader?.rtnMsg);
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  const handleChart = (rowData) => {
    navigate("dashboard", { state: { itemObj: rowData } });
  };

  const exportWord = (rowData) => {
    //產生報告書
    setReportListObj([rowData]); //設定目前選了哪筆報告書
    rowData.companySeq = getValues("companySeq");
    setItemObj(rowData);
    setAction("report");
    setTab1Action("report");
    navigate("report", { state: { companyName: rowData?.companyName } });
  };

  const confirmDel = () => {
    checkLoading(loading);
    deleteFootprintItem({ carbonFpId: delObj?.carbonFpId })
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.delete") + " " + t("message.success"));
          setDelDialog(false);
          axios_queryCarbonFootprintList({
            companySeq: getValues("companySeq"),
            productType: getValues("productType"),
          });
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  const formatWithCommastTemplate = (value, str = "") => {
    return (
      <>
        {
          <>
            {NumberUtil.formatWithCommas(value)}
            {str}
          </>
        }
      </>
    );
  };

  const copyItem = (rowData) => {
    setCopyDialog(true);
    setCopyObj(rowData);
  };

  const actionBodyTemplate = (rowData, props) => {
    if (rowData) {
      return (
        <>
          {/* 標的資料 */}
          <Button
            tooltip={t("button.target")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              editItem(rowData, "detail");
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-eye" />
          </Button>
          {/* 足跡盤查 */}
          <Button
            tooltip={t("button.carbonFootprint")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              editItem(rowData, "footprint");
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-shoe-prints" />
          </Button>
          {/* 清冊 - 根據權限控制 */}
          <Button
            tooltip={t("button.inventory")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            disabled={!hasTabPermission("inventory")}
            onClick={() => {
              exportItem(rowData);
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-file-export" />
          </Button>

          {/* 報告書 - 根據權限控制 */}
          <Button
            tooltip={t("button.report")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            disabled={!hasTabPermission("report")}
            onClick={() => {
              exportWord(rowData);
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-file-arrow-down" />
          </Button>
          {/* 儀表板 */}
          <Button
            icon="pi pi-chart-pie"
            tooltip={t("button.dashboard")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              handleChart(rowData);
            }}
          ></Button>
          {/* 複製 */}
          <Button
            tooltip={t("button.copy")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              copyItem(rowData);
            }}
            disabled={!isEditable}
          >
            <FontAwesomeIcon icon="fa-solid fa-copy" />
          </Button>
          {/* 刪除 */}
          <Button
            tooltip={t("button.delete")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              deleteItem(rowData);
            }}
            disabled={!isEditable}
          >
            <FontAwesomeIcon icon="fa-solid fa-trash" />
          </Button>
        </>
      );
    }
  };

  const axios_queryCompanyProduct = (reqBody) => {
    queryCompanyProduct(reqBody).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res?.data?.RespBody?.evaluationTemplates?.options;
        setComProductList(data);
      }
    });
  };

  const axios_copyCarbonFootprint = (reqBody) => {
    checkLoading(loading);
    copyCarbonFootprint(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.copy") + " " + t("message.success"));
          setCopyOffingId(null);
          setIsCopyFile("N");
          setCopyDialog(false);
          axios_queryCarbonFootprintList({ companySeq: currentComSeq });
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  const tooltipTargetTemplate = (rowData, props) => {
    const tooltipContent = rowData?.[props?.field] || "";
    if (!tooltipContent) return null;

    return (
      <span
        ref={(el) => setTooltipTarget(el)}
        data-pr-tooltip={tooltipContent}
        data-pr-position="bottom"
        className="nameBody text-ellipsis"
      >
        {tooltipContent}
      </span>
    );
  };

  return (
    <>
      <div className="p-card bg-gray">
        <div className="p-card-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid">
              <div className="col-12 lg:col-6">
                <label htmlFor="placeName" className="form-label required">
                  {t("organName")}
                </label>
                <Controller
                  name="companySeq"
                  control={control}
                  rules={{ required: { value: true, message: t("validation.required") } }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      loading={isLoading.toString() === "true" ? 1 : 0}
                      filter
                      disabled={getCompanyType() === "A"}
                      appendTo={"self"}
                      optionLabel="companyName"
                      optionValue="companySeq"
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name="companySeq"
                      control={control}
                      options={companyPlaceList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                        // 切換組織名稱時清空下面的資訊
                        setCarbonFootprintLists([]);
                        setCarbonFpId("");
                        setCreateButtonFlag(false);
                        resetField("productType");
                        // 設定選中的組織給子元件使用
                        setCurrentComSeq(event.value);
                        let companyList = companyPlaceList?.filter((item) => item.companySeq === event.value);
                        setCompanyName(companyList[0]?.companyName);
                        axios_queryCarbonFootprintList({
                          companySeq: event.value,
                        });
                      }}
                    />
                  )}
                />
                {getFormErrorMessage(errors, "companySeq")}
              </div>
              <div className="col-12 lg:col-6">
                <label htmlFor="productType" className="form-label">
                  {t("productType")}
                </label>
                <Controller
                  name="productType"
                  control={control}
                  // rules={{ required: { value: true, message: t('validation.required') } }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      loading={isLoading.toString() === "true" ? 1 : 0}
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      showClear
                      appendTo={"self"}
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs_all")}
                      name="productType"
                      control={control}
                      options={productTypeList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
                {getFormErrorMessage(errors, "companySeq")}
              </div>
              {/* <div className="col-12 lg:col-4">
          <label
              htmlFor="placeName"
              className="form-label">
              {t('queryYear_roc')}
            </label>
            <Controller
                name="startYear"
                control={control}
                render={({ field, fieldState }) => (
                  <Dropdown
                    filter
                    appendTo={"self"}
                    optionLabel="subitemName"
                    optionValue="subitemNo"
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs")}
                    name="startYear"
                    control={control}
                    options={planYearList}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                    }}
                  />
                )}
              />
              {getFormErrorMessage(errors, "startYear")}
            
          </div> */}
            </div>

            <div className="col-12 gap-2 flex-all-center">
              <Button disabled={!isValid} type="submit" label={t("button.query")} />
              <Button
                outlined
                type="button"
                disabled={!isEditable || !currentComSeq}
                onClick={() => {
                  if (!createButtonFlag) {
                    setLimitDialog(true);
                  } else {
                    createItem();
                  }
                }}
                label={t("button.create")}
              />
            </div>
          </form>
        </div>
      </div>

      <div className="p-card">
        <div className="p-card-body">
          <DataTable
            stripedRows
            className="white-data-table hover-highlight no-shadow"
            tableStyle={{ minWidth: "55rem" }}
            footer={
              carbonFootprintLists?.length > 0 && (
                <PrimeTableFooter rowDataList={carbonFootprintLists} isShowMore={true} btnReadMore={btnReadMore} />
              )
            }
            emptyMessage={<NoInfo panel="table" size="md" />}
            value={carbonFootprintLists}
            resizableColumns
          >
            <Column
              field="productName"
              header={t("product_name")}
              bodyStyle={{ maxWidth: "200px" }}
              body={tooltipTargetTemplate}
            ></Column>
            <Column field="productTypeName" header={t("productType")}></Column>
            <Column
              field="quantity"
              header={t("total_quantity")}
              body={(rowData) => formatWithCommastTemplate(rowData.quantity)}
              style={{ textAlign: "right" }}
            ></Column>
            <Column
              field="unitWeightKg"
              header={t("unitWeightkg")}
              body={(rowData) => formatWithCommastTemplate(rowData.unitWeightKg)}
              style={{ textAlign: "right" }}
            ></Column>
            <Column
              field="totalWeight"
              header={t("totalWeightkg")}
              body={(rowData) => formatWithCommastTemplate(rowData.totalWeight)}
              style={{ textAlign: "right" }}
            ></Column>
            <Column
              field="productRatio"
              header={t("productRatio")}
              body={(rowData) => formatWithCommastTemplate(rowData.productRatio, "%")}
              style={{ textAlign: "right" }}
            ></Column>
            <Column field="inspectionDate" header={t("queryYear")}></Column>
            <Column header={t("action")} body={actionBodyTemplate}></Column>
          </DataTable>
        </div>
      </div>

      {tooltipTarget && <Tooltip mouseTrack target=".nameBody" position="bottom" event="hover" />}

      {/* 刪除 */}
      <PrimeConfirmDialog
        visible={delDialog}
        onClose={() => {
          setDelDialog(false);
        }}
        onConfirm={() => {
          confirmDel();
        }}
        title={t("button.delete")}
        bodyTemplate={<>{t("conf_del", { name: delObj?.productName })}</>}
      />

      {/* 碳足跡報告上限 */}
      <PrimeDialog
        visible={limitDialog}
        isShowConfBtn={false}
        onClose={() => {
          setLimitDialog(false);
        }}
        title={t("button.create")}
        bodyTemplate={<>{t("createCountLimitReachedTip")}</>}
      />

      {/* 複製 */}
      <PrimeDialog
        visible={copyDialog}
        size="sm"
        disabledConfirm={!isCopyFile || !copyOffingId}
        onClose={() => {
          setCopyDialog(false);
          setIsCopyFile("Y");
          setCopyOffingId("");
        }}
        title={t("button.copy")}
        onConfirm={() => {
          axios_copyCarbonFootprint({
            carbonFpId: copyObj?.carbonFpId,
            offeringsId: copyOffingId,
            copyFileFlag: isCopyFile,
          });
        }}
        bodyTemplate={
          <div className="grid">
            {/* 產品名稱 */}
            <div className="col-12">
              <label className="form-label font-bold">{t("product_name")}</label>
              <span>{copyObj.productName}</span>
            </div>
            {/* 複製到 */}
            <div className="col-12">
              <label className="form-label font-bold">{t("copyTo")}</label>
            </div>
            {/* 產品名稱 */}
            <div className="col-12">
              <label htmlFor="offeringsId" className="form-label font-bold">
                {t("product_name")}
              </label>
              <Dropdown
                filter
                optionLabel="label"
                optionValue="value"
                value={copyOffingId}
                virtualScrollerOptions={{ itemSize: 40 }}
                defaultValue={""}
                placeholder={t("plz_chs")}
                options={comProductList}
                className={`w-full`}
                onChange={(event) => {
                  setCopyOffingId(event.value);
                }}
              />
            </div>
            {/* 包含所有檔案 */}
            <div className="col-12">
              <div className="flex flex-wrap gap-2">
                <Checkbox
                  inputId="isCopyFile"
                  checked={isCopyFile === "Y"}
                  onChange={(e) => setIsCopyFile(e.checked ? "Y" : "N")}
                />
                {t("doesIncludeAllFiles")}
              </div>
            </div>
          </div>
        }
      />
    </>
  );
}
